import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// api
import baseApi from "../../api/baseApi";

// diğer importlar
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
  isLoading: false,
  autoClose: 5000,
  transition: Slide,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const initialState = {
  user: {},
  userLoading: true,
  userRefresh: true,

  users: [],
  usersLoading: true,
  usersRefresh: true,

  roles: [],
  rolesLoading: true,
  rolesRefresh: true,

  createUserLoading: false,
  updateUserLoading: false,
  changePasswordLoading: false,
  deleteUserLoading: false,
};

export const fetchUser = createAsyncThunk("user/fetchUser", async (id) => {
  if (!id) {
    const errMsg = "Id bulunamadı!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }

  try {
    const response = await baseApi.get(`/Users/${id}`);

    return response.data.result;
  } catch (error) {
    const errMsg =
      error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }
});

export const fetchUsers = createAsyncThunk("user/fetchUsers", async () => {
  try {
    const response = await baseApi.get(`/Users`);

    return response.data.result;
  } catch (error) {
    const errMsg =
      error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }
});

export const fetchUserRoles = createAsyncThunk(
  "user/fetchUserRoles",
  async () => {
    try {
      const response = await baseApi.get(`/Users/Role`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const createUser = createAsyncThunk(
  "user/createUser",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      nameSurname: values.nameSurname,
      phoneNumber: values.phoneNumber,
      password: values.password,
      roleId: values.roleId,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Users`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      id: values.id,
      nameSurname: values.nameSurname,
      phoneNumber: values.phoneNumber,
      roleId: values.roleId,
      isActive: values.isActive,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/Users/${values.id}`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      phoneNumber: values.phoneNumber,
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Users/ChangePassword`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const deleteUser = createAsyncThunk("user/deleteUser", async (id) => {
  if (!id) {
    const errMsg = "Id bulunamadı!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }

  const loadingToast = toast.loading("Siliniyor...", {
    transition: Slide,
  });

  try {
    const response = await baseApi.delete(`/Users/${id}`);

    toast.update(loadingToast, {
      render: "Silindi.",
      type: "success",
      isLoading: false,
      autoClose: 5000,
      transition: Slide,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });

    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

    toast.update(loadingToast, {
      render: errMsg,
      type: "error",
      ...toastConfig,
    });

    throw new Error(errMsg);
  }
});

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state, action) => {
        state.userLoading = true;
        state.user = {};
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.userLoading = false;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.user = {};
        state.userLoading = false;
      });

    builder
      .addCase(fetchUsers.pending, (state, action) => {
        state.usersLoading = true;
        state.users = [];
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.users = action.payload;
        state.usersLoading = false;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.users = [];
        state.usersLoading = false;
      });

    builder
      .addCase(fetchUserRoles.pending, (state, action) => {
        state.rolesLoading = true;
        state.roles = [];
      })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.roles = action.payload;
        state.rolesLoading = false;
      })
      .addCase(fetchUserRoles.rejected, (state, action) => {
        state.roles = [];
        state.rolesLoading = false;
      });

    builder
      .addCase(createUser.pending, (state, action) => {
        state.createUserLoading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.createUserLoading = false;
        state.usersRefresh = !state.usersRefresh;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.createUserLoading = false;
      });

    builder
      .addCase(updateUser.pending, (state, action) => {
        state.updateUserLoading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.updateUserLoading = false;
        state.usersRefresh = !state.usersRefresh;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.updateUserLoading = false;
      });

    builder
      .addCase(changePassword.pending, (state, action) => {
        state.changePasswordLoading = true;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.changePasswordLoading = false;
        state.usersRefresh = !state.usersRefresh;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.changePasswordLoading = false;
      });

    builder
      .addCase(deleteUser.pending, (state, action) => {
        state.deleteUserLoading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.deleteUserLoading = false;
        state.usersRefresh = !state.usersRefresh;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.deleteUserLoading = false;
      });
  },
});

export default userSlice.reducer;
